<template>
  <div class="flex justify-center w-1/3 my-8">
    <input
      ref="hiddenHolder"
      type="hidden"
      @input="updateValue"
    >
    <div
      v-for="item in cells"
      :key="item.idx"
    >
      <input
        :ref="item.ref"
        v-model="verificationCode[item.idx]"
        :data-test="`verification-${item.idx}`"
        :maxlength="item.maxlength"
        class="text-center border border-bordergray w-10 h-10 rounded mr-2"
        @keydown.enter="$emit('enter')"
        @keydown.delete="deleteCode($event, item.idx)"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'VerificationInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    length: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      verificationCode: [],
      verificationCodeStr: '',
    };
  },
  computed: {
    cells() {
      return Array.from(Array(this.length).keys()).map((n) => ({
        maxlength: n === 0 ? this.length : 1,
        idx: n,
        ref: `key${n}`,
      }));
    },
  },
  watch: {
    verificationCode(newValue) {
      let code;
      if (newValue[0] && newValue[0].length > 1) {
        code = newValue[0].split('');
      } else {
        code = newValue;
      }
      // this won't cause infinite loop since we are not changing the
      // value of verificationCode in second-time
      this.verificationCode = code;
      this.updateValue({
        target: {
          value: code.join(''),
        },
      });
    },
    value: {
      immediate: true,
      handler(newValue) {
        this.verificationCodeStr = newValue;
        this.verificationCode = newValue.split('');

        if (newValue.length === this.length && this.verificationCodeStr.length === this.length) {
          this.$emit('enter');
        }
      },
    },
  },
  methods: {
    updateValue(e) {
      const isDelete = e.target.value.length < this.verificationCodeStr.length;
      this.$emit('input', e.target.value);
      this.verificationCodeStr = e.target.value;

      if (e.target.value.length === this.length || isDelete) {
        return;
      }

      const focusKey = `key${e.target.value.length}`;
      this.$refs[focusKey][0].focus();
    },
    deleteCode(e, pos) {
      if (pos === 0) return;
      if (!e.target.value) {
        this.$refs[`key${pos - 1}`][0].focus();
      }
    },
  },
};
</script>
